import React, { useContext, useState, useEffect } from 'react';
import { useStyles } from '../../style';
import { Box, Grid, TextField, Typography, Autocomplete, Chip } from '@mui/material';

import KenButton from '../../../../GlobalComponents/KenButton';
import { borderRadius } from '@mui/system';
import { postBasicProfileSetting, updatePreferencesandSkills } from '../../../../Utils/apiService'; // Import the API function
import { AuthContext } from '../../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../../interfaces/Contexts';
import { enqueueSnackbar } from 'notistack';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid white',
  boxShadow: 24,
  borderRadius: 2,
  width: { lg: '35vw', xl: '35vw' },
  p: 2,
  overflowY: 'auto',
};

const AddSkill = (props: any) => {
  console.log('propspropspropspropsprops', props);
  const {
    state: { user },
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const [inputValue, setInputValue] = useState('');
  const classes = useStyles();
  const [skills, setSkills] = useState<string[]>([]); // State to store selected skills
  const [processedSkills, setProcessedSkills] = useState<{ label: string; value: string }[]>([]); // State for Autocomplete options

  // Initialize skills from props
  useEffect(() => {
    if (props?.skills?.Skills__c) {
      const initialSkills = props.skills.Skills__c.split(';').map((skill: string) => ({
        label: skill.trim(),
        value: skill.trim(),
      }));
      setProcessedSkills(initialSkills);
      setSkills(initialSkills.map((skill: { value: any; }) => skill.value));
    }
  }, [props?.skills?.Skills__c]);

  const handleSave = async () => {
    try {
      let finalSkills = [...skills];

      if (inputValue.trim()) {
        const trimmed = inputValue.trim();
        const isDuplicate = finalSkills.some(
          (skill) => skill.toLowerCase() === trimmed.toLowerCase()
        );

        if (!isDuplicate) {
          finalSkills.push(trimmed);
        }
      }

      const payload = {
        recordId: props?.skills?.Id,
        Skills__c: finalSkills.join(';'),
      };

      await updatePreferencesandSkills(payload).then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar({
            message: 'Your skills has been update Successfully',
            variant: 'success',
            autoHideDuration: 1000,
          });
          props.handleClose();
          props?.setSkill((prev: any) => [...prev, ...finalSkills]);
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      });
    } catch (error) {
      console.error('Error saving skills:', error);
      enqueueSnackbar({ message: 'Error saving skills', variant: 'error', autoHideDuration: 1000 });
    }
  };

  return (
    <div>
      <Box sx={style}>
        <Typography sx={{ textAlign: 'left', fontWeight: 550, fontSize: '13px' }}>
          {props.data == 'edit' ? 'Edit Skills' : 'Add Skills'}
        </Typography>
        <hr style={{ border: '1px solid #E6E6E8' }} />
        <Grid container spacing={2} sx={{ marginTop: '-40px' }}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography sx={{ fontWeight: 500, mt: 2, fontSize: '12px' }}>Skills</Typography>
            <Autocomplete
              multiple
              freeSolo
              id="skills-autocomplete"
              options={[]} // No predefined options
              value={processedSkills}
              onChange={(_, newValue) => {
                const updatedSkills = newValue.map((item: any) =>
                  typeof item === 'string'
                    ? { label: item, value: item }
                    : { label: item.label, value: item.value }
                );
                setProcessedSkills(updatedSkills);
                setSkills(updatedSkills.map((item) => item.value));
              }}

              filterSelectedOptions
              inputValue={inputValue}
              onInputChange={(_, newInputValue, reason) => {
                if (reason === 'input') {
                  setInputValue(newInputValue);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Skills"
                  placeholder="Enter your skills"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && inputValue.trim()) {
                      e.preventDefault();

                      const trimmed = inputValue.trim();

                      // Prevent duplicate entry
                      const isDuplicate = processedSkills.some(
                        (skill) => skill.label.toLowerCase() === trimmed.toLowerCase()
                      );

                      if (!isDuplicate) {
                        const newSkill = { label: trimmed, value: trimmed };
                        const updatedProcessed = [...processedSkills, newSkill];
                        setProcessedSkills(updatedProcessed);
                        setSkills(updatedProcessed.map((skill) => skill.value));
                      }

                      setInputValue('');
                    }
                  }}
                  sx={{
                    margin: '6px 0px',
                    '& .MuiOutlinedInput-root': {
                      height: 'auto',
                      minHeight: '60px',
                      overflowY: 'visible',
                      borderRadius: '6px',
                      fontSize: '14px',
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'flex-start',
                      paddingTop: '8px',
                      paddingBottom: '8px',
                    },
                    '& .MuiInputBase-input::placeholder': {
                      fontSize: '14px',
                      '@media (max-width: 1440px)': {
                        fontSize: '12px',
                      },
                    },
                  }}
                />
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => {
                  const label = typeof option === 'string' ? option : option.label;
                  return <Chip label={label} {...getTagProps({ index })} />;
                })
              }
            />
          </Grid>
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
          <KenButton
            variant="text"
            className={classes.button}
            sx={{
              mt: 1,
              borderRadius: '8px',
              width: 100,
              '&:hover': {
                backgroundColor: 'transparent',
              },
              '&:active': {
                backgroundColor: 'transparent',
              },
              '&:focus': {
                backgroundColor: 'transparent', // Ensures no background on focus
              },
              '&:focus-visible': {
                backgroundColor: 'transparent', // Ensures no background on keyboard focus
              },
              color: 'black',
            }}
            onClick={props.handleClose}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#373A45' }}>Cancel</Typography>
          </KenButton>
          <KenButton
            variant="contained"
            className={classes.button}
            style={{
              marginTop: 15,
              borderRadius: '8px',
              width: 100,
              marginLeft: 10,
              height: '36px',
              boxShadow: 'none',
              color: "#5b4200",
            }}
            onClick={handleSave} // Call handleSave on click
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Save</Typography>
          </KenButton>
        </Box>
      </Box>
    </div>
  );
};

export default AddSkill;
